import React from 'react';
import { useLocalStorageState } from 'ahooks';
import { useRequestNewPassword } from 'Account/hooks/auth';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import ForgotPasswordForm, { FormValues } from './views/ForgotPasswordForm';

const ForgotPassword = () => {
  const requestNewPasswordMutation = useRequestNewPassword();
  const [_, setAccount] = useLocalStorageState<AccountPersistInfo>('account');
  const submitHandler = (data: FormValues) => {
    setAccount(
      (prev) => ({ ...prev, email: data.email } as AccountPersistInfo)
    );
    requestNewPasswordMutation.mutate(data);
  };
  return <ForgotPasswordForm handleSubmit={submitHandler} />;
};
export default ForgotPassword;
